//////////////////////////// freeee product js /////////////////////////////
function addFreeProducts() {
  var FreeProduct = 32070009585700;
  $.ajax({
    url:'/cart/add.js',
    type:'POST',
    dataType: 'json', 
    data: "quantity="+1+"&id="+FreeProduct,
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart', 
        dataType: 'html',
        success: function(response) {
          $('#cartForm').load(' #cartForm');
          $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
          $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
          $('body').addClass('drawer_open');	
        },
      });
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': Shopify.currency.active,
          'add': {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name': response.title,
              'id': response.product_id,
              'price': Shopify.formatMoney(response.final_price, $('body').attr('data-moneyform')),
              'brand': response.vendor,
              'variant': response.variant_id,
              'quantity': response.quantity
            }]
          }
        }
      });
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
    }
  })
}
function removeFreeProducts() {
  var FreeProduct = 32070009585700;
  $.ajax({
    url:'/cart/change.js',
    type:'POST',
    dataType: 'json',
    data: "quantity="+0+"&id="+FreeProduct,
    success: function(response){
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(response) {
          $('#cartForm').load(' #cartForm');
          $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
          $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
          $('body').addClass('drawer_open');	
        },
      });
    }
  })
}

function reloadCart() {
  $.ajax({
    type: 'GET',
    url: '/cart',
    dataType: 'html',
    success: function(response) {
      $('#cartForm').load(' #cartForm');
      $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
      $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
      $('body').addClass('drawer_open');	
    },
  });
}


function checkCartitems() {
  var FREE_PRODUCT_IDS = [32070009585700];
  var freebie = false;
  var RemoveProduct = false;
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: "JSON",
    success: function (cart) {
      $.each(cart.items, function (index, item) {
        if (FREE_PRODUCT_IDS == item.id) {
          if (cart.total_price > 5000) {
            freebie = false;
            return false
          }
          else{
            RemoveProduct = true;
            return false;
          } 
        }
        else{
          if (cart.total_price > 5000 && $.cookie('FreeRosecleanRemove') == 'null'  ) {
            freebie = true
          }
        }
      });
      if(RemoveProduct == true){
        removeFreeProducts();
      }
      else{
        if (freebie == true) {
          if (cart.total_price > 5000) {
            addFreeProducts();
          }
          else{
            reloadCart();
          }
        }
        else{
          reloadCart()
        }
      }

    }
  });
}

$(document).on('click', '.product_add_cart', function(e){
  e.preventDefault();
  var textChnage = $(this);
  $(textChnage).children('[data-add-to-cart-text]').addClass('hide');
  $(textChnage).children('.custom-minus').addClass('hide');
  $(textChnage).children('.product__price').addClass('hide');
  $(textChnage).children('[data-loader]').removeClass('hide');
  var data = $(this).parents('form').serialize();
  $.ajax({
    url:'/cart/add.js',
    type:'POST',
    dataType: 'json',
    data: data,
    success: function(response){
      reloadCart();
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': Shopify.currency.active,
          'add': {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name': response.title,
              'id': response.product_id,
              'price': Shopify.formatMoney(response.final_price, $('body').attr('data-moneyform')),
              'brand': response.vendor,
              'variant': response.variant_id,
              'quantity': response.quantity
            }]
          }
        }
      });
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
    },
    error: function(){
      $(textChnage).val('Épuisé');
      setTimeout(function(){
        $(textChnage).val('Ajouter au panier');
      },1000);
    },
    complete: function(){ 
      $(textChnage).children('[data-add-to-cart-text]').removeClass('hide');
      $(textChnage).children('.custom-minus').removeClass('hide');
      $(textChnage).children('.product__price').removeClass('hide');
      $(textChnage).children('[data-loader]').addClass('hide');
    }
  });
});  

$(document).on('click', '.Cv_custom_add_cart', function(e){
  e.preventDefault();
  var textChnage = $(this);
  $(textChnage).children('.add_to_cart').addClass('hide');
  $(textChnage).children('.product__price').addClass('hide');
  $(textChnage).children('[data-loader]').removeClass('hide');
  var data = $(this).parents('form').serialize();
  $.ajax({
    url:'/cart/add.js',
    type:'POST',
    dataType: 'json', 
    data: data,
    success: function(response){
      reloadCart();
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      window.dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': Shopify.currency.active,
          'add': {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name': response.title,
              'id': response.product_id,
              'price': Shopify.formatMoney(response.final_price, $('body').attr('data-moneyform')),
              'brand': response.vendor,
              'variant': response.variant_id,
              'quantity': response.quantity
            }]
          }
        }
      });
      //       ----------------------------------------------------------------------------------------------------------------------------- 
      //       ----------------------------------------------------------------------------------------------------------------------------- 
    },
    error: function(){
      $(textChnage).val('Épuisé');
      setTimeout(function(){
        $(textChnage).val('Ajouter');
      },1000);
    },
    complete: function(){ 
      $(textChnage).children('.add_to_cart').removeClass('hide');
      $(textChnage).children('.product__price').removeClass('hide');
      $(textChnage).children('[data-loader]').addClass('hide');
    }
  });
});

/////////////////////// endcode here ////////////////

function updateQuantity(line,quantity){
  $.ajax({
    type: 'POST',
    url: '/cart/change',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      reloadCart();
    }
  });
} 


$(".open").on("click", function(){
  $(".popup, .popup-content").addClass("active");
});
$(".close, .popup").on("click", function(){
  $(".popup, .popup-content").removeClass("active");
});


$('.open-popup').on('click', function(e) {
  e.preventDefault
  openpopupnow();
});

$('.popup-close').on('click', function() {
  $('.overlay').removeClass('shown');
});
$('.btn_yes').on('click', function() {
  $('.overlay').removeClass('shown');
}); 
$(document).on('keyup', function(event) {
  if (event.which == 27) { // esc
    $('.overlay').removeClass('shown');
  };
});
function openpopupnow() {
  var mpopup = $('.overlay');
  mpopup.addClass('shown');

  $(window).on('click', function(e) {
    if(e.target == mpopup[0]){
      mpopup.removeClass('shown'); 
    } 
  }); 
}
 
$(document).on('click', '.comingSoonPopup', function(e){
  e.preventDefault();
  var NameProduct,CapturePopup;
  var NameProduct = $(this).attr('Productname');
  if( NameProduct.lastIndexOf("|") ){
    NameProduct = NameProduct.substring(0, NameProduct.lastIndexOf("|") + 1); 
  }
  NameProduct = NameProduct.replace(/[^A-Z0-9]/ig, "");
  NameProduct = $.trim(NameProduct).toLowerCase();
  $(this).parents('body').find('.ComingSoonCollectionPopup').children('.popUpComingSoonProduct').each(function(){
    CapturePopup = $(this).attr('capturepopup');
    CapturePopup = $.trim(CapturePopup).toLowerCase();
    if( NameProduct == CapturePopup){ 
      $(this).addClass('active');
      return false;
    } 
  });
});

$(document).on('click', '.comingSoonPopupClose', function(e){  
  e.preventDefault();
  $('.popUpComingSoonProduct').removeClass('active');
  $('body').removeClass('soonPopupMasked');
});

$(document).on('click', '#custom-add-drawer', function(e){
  $('#custom-add-new').addClass('active-side-bar-menu');
  $('body').addClass('body_masked');
}); 
$(document).on('click', '.cv-icon-close', function(e){
  $('#custom-add-new').removeClass('active-side-bar-menu');
  $('body').removeClass('body_masked');
}); 
$(document).click(function (e) {
  if (!$(e.target).closest('#custom-add-drawer, #custom-add-new').length) {
    $('#custom-add-new').removeClass('active-side-bar-menu');
    $('body').removeClass('body_masked');
  }
});
$(document).on('click', '.qtybox .btnqty', function(e){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {qty--;}
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 
$(document).ready(function(){
  $('.content-logo-block-mn').children('.index-logo-blockGrid').first().addClass('active');
  $('.content_hover_block_mn').children('.main-index-text-with-logo').first().addClass('active');
  $('.one-time-mobile').slick({
    infinite: true,
    speed: 300, 
    slidesToShow: 1, 
    arrows: false, 
    dots: true, 
    adaptiveHeight: true
  });
  $('.SliderWrapAnnouncemnetBar').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover:false,
    pauseOnFocus:false
  }); 
  $(document).on('click', '.cv_cart_draweradd', function(e){
    e.preventDefault();
    $(this).prev().val(+$(this).prev().val() + 1); 
    var line = $(this).attr('data-line');
    var quantity = $(this).prev().val();
    updateQuantity(line,quantity); 
  });
  $(document).on('click', '.cv_cart_drawersub', function(e){
    e.preventDefault();
    $(this).next().val(+$(this).next().val() - 1);
    var line = $(this).attr('data-line');
    var quantity = $(this).next().val();
    updateQuantity(line,quantity);
  });

  $(document).on('click touchend', '.cvv_header_cart_outer', function(e){
    e.preventDefault();
    $('.cart_drawer').addClass('cart_drawer_open');
    $('body').addClass('drawer_open');
  }); 
  $(document).on('click', '.cv_cart_close', function(e){
    e.preventDefault();
    $('.cart_drawer').removeClass('cart_drawer_open');
    $('body').removeClass('drawer_open');
  });

  $(document).on('click', '.blank_div_ct', function(e){
    e.preventDefault();
    $('.cart_drawer').removeClass('cart_drawer_open');
    $('body').removeClass('drawer_open'); 
    window.location.replace("/");
  }); 

  $(document).on('click touchstart','.cart__remove',function(e){ 
    e.preventDefault();
    var url = $(this).attr('href');
    $.ajax({
      url:url,
      type:'GET',
      success: function(response){
        $('[data-cart-count]').html($(response).find('[data-cart-count]').html())
        $('.cart_drawer').html($(response).find('.cart_drawer').html()).addClass('cart_drawer_open');
        $('body').addClass('drawer_open');
      }
    });
  });

  $(document).click(function (e) {
    if (!$(e.target).closest('.mn_bch, .cv-cross-title, .cvv_header_cart_outer,.fancybox-opened,.fancybox-close').length) {
      $('.cart_drawer').removeClass('cart_drawer_open');
      $('body').removeClass('drawer_open');
    }
  });

//   $(document).on("click",".qtyplus",function() {
//     var quantity = $(this).parents('.qtybox').find('[name="quantity"]').val();
//     var initialPrice = $(this).parents('.qtybox').find('[name="quantity"]').attr('product_price'); 
//     var newPrice = (parseFloat(initialPrice) * quantity).toFixed(2);
//     newPrice = newPrice.toString().replace(/\./g, ',');
//     $('.upd-pro-price').html(newPrice+'€');
//   });
//   $(document).on("click",".qtyminus",function() {
//     var quantity = $(this).parents('.qtybox').find('[name="quantity"]').val();
//     var initialPrice = $(this).parents('.qtybox').find('[name="quantity"]').attr('product_price'); 
//     var newPrice = (parseFloat(initialPrice) * quantity).toFixed(2);
//     newPrice = newPrice.toString().replace(/\./g, ',');
//     $('.upd-pro-price').html(newPrice+'€');
//   });
  $(document).on('click', '.cv-swatch .color_input_change', function(){
    var mg= $(this).attr('feature_image');
    var vid= $(this).attr('attribute_id');
    $(this).parents('label').addClass('active').siblings().removeClass('active');
    $(this).parents('li').find('img').attr('srcset',mg);
    $(this).parents('.custom_product_main').find('[name=id]').val(vid);
  });

  $(document).on('click', '.index-page-swatch .color_input_change', function(){
    var mg= $(this).attr('feature_image');
    var vid= $(this).attr('attribute_id');
    $(this).parents('label').addClass('active').siblings().removeClass('active');
    $(this).parents('.custom_product_main').find('.mn_image').attr('src',mg);
    $(this).parents('.custom_product_main').find('.mn_image_one').attr('src',mg);
    $(this).parents('.custom_product_main').find('[name=id]').val(vid);
  });

  if ($(window).width() > 749) {
    $('.main_image_product_slide').slick({    
      slidesToShow: 1, 
      slidesToScroll: 1,  
      arrows: false,
      dots: false,  
      fade:true,
      asNavFor: '.thumb_mn_slide'    
    });
    $('.thumb_mn_slide').slick({ 
      slidesToShow: 600,
      slidesToScroll: 1, 
      vertical:true,
      asNavFor: '.main_image_product_slide', 
      dots: false, 
      arrows: false, 
      focusOnSelect: true,
      verticalSwiping:true, 
    });
  } 

  if ($(window).width() < 750) {
    $('.main_image_product_slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    }); 
  }

  $('.product-description-cv .more').click(function(e) {
    e.preventDefault();
    $(this).text(function(i, t) {
      return t == 'weniger sehen' ? 'Mehr erfahren' : 'weniger sehen';
    }).prev('.product-description-cv .more-cont').slideToggle()
  });

  $('.content-logo-block-mn').children('.index-logo-blockGrid').hover(function(){
    $(this).addClass('active').siblings().removeClass('active');
    var logoHover = $(this).index();
    $('.content_hover_block_mn').children('.main-index-text-with-logo').each(function(){
      var logoTex = $(this).index();
      $(this).removeClass('active');
      if( logoHover == logoTex){
        $(this).addClass('active');
      }
    });
  })
  $('.cv-product-description').css('display','none');
  $('.product-page-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  //   $(".accordion_head").click(function() {
  //     if ($('.accordion_body').is(':visible')) {
  //       $(".accordion_body").slideUp(300);
  //     }
  //     if ($(this).next(".accordion_body").is(':visible')) {
  //       $(this).next(".accordion_body").slideUp(300);
  //     } else {
  //       $(this).next(".accordion_body").slideDown(300);
  //     }
  //   });
});


//discount cart  coupon code js
$(document).on('click', '#redemDevPromo', function(){
  event.preventDefault();
  var theUrl = '/checkout?discount=';
  var theDiscount = $('#devPromo').val();
  var toRedirect = theUrl+theDiscount;
  window.location.href = toRedirect;
});



$(document).on('click', '#cv-promofield', function(){
  $("#cv-promofield").addClass("hide");
  $("#remove-cart-text").removeClass("hide");
});
$(document).on('click', '.TextFieldSpan-m72orh-1', function(){
  $(".TextFieldSpan-m72orh-1").css("color", "#f696a8");
});

// end discaount coupon code

function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Mehr erfahren"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "weniger sehen"; 
    moreText.style.display = "inline";
  }
}


$(document).ready(function(){
  $(".review_highlight").addClass("hide");
  $("#review-cvacc").addClass("hide");
});

$(document).ready(function(){
  $("#review-accordion-k").click(function(){
    $("#review-cvacc").toggleClass("hide");
    $(".review_highlight").toggleClass("hide");
  });
});

$(function() {
  // Open Popup
  $('[popup-open]').on('click', function() { 
    var popup_name = $(this).attr('popup-open');
    $('[popup-name="' + popup_name + '"]').fadeIn(300);
  });

  // Close Popup
  $('[popup-close]').on('click', function() {
    var popup_name = $(this).attr('popup-close');
    $('[popup-name="' + popup_name + '"]').fadeOut(300);
  });

  // Close Popup When Click Outside
  $('.popup').on('click', function() {
    var popup_name = $(this).find('[popup-close]').attr('popup-close');
    $('[popup-name="' + popup_name + '"]').fadeOut(300);
  }).children().click(function() {
    return false;
  });
});

$(".open-button").click(function(){
  $('body').addClass('cv-popup-add')
});
$(document).click(function (e) {
  if (!$(e.target).closest('.open-button').length) {
    $('body').removeClass('cv-popup-add')
  }
});

$(".close-button").click(function(){
  $('body').removeClass('cv-popup-add') 
});

$("#cv-button--hover").hover(function(){
  $('#AccessibleNav').addClass('cv-nav-hover')
});
$('#AccessibleNav').mouseleave(function()
                               {
  $(this).removeClass('cv-nav-hover')
});

$('.image-blog-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: false,
  fade:true,
});

$('#review-accordion-k').click(function(){
  $('#review-accordion-k').toggleClass('active');
});

// $('#add-heading-d').click(function(){
//   $('#add-heading-d').toggleClass('active');
// });

$('.open-popup').on('click', function() {
  openpopupnow();
});

$('.popup-close').on('click', function() {
  $('.overlay').removeClass('shown');
});
$('.btn_yes').on('click', function() {
  $('.overlay').removeClass('shown');
});
$(document).on('keyup', function(event) {
  if (event.which == 27) { // esc
    $('.overlay').removeClass('shown');
  };
});
function openpopupnow() {
  var mpopup = $('.overlay');
  mpopup.addClass('shown');

  $(window).on('click', function(e) {
    if(e.target == mpopup[0]){
      mpopup.removeClass('shown');
    }
  });
}

$(document).on('click', '.cv-fancybox', function(){
  $('body').addClass('sec-custom-fancy') 
  $.fancybox([
    { href : '#cv-fancybox-popup-form' }
  ]);
});

$(document).click(function (e) {
  if (!$(e.target).closest('.cv-fancybox,.fancybox-opened').length) {
    $('body').removeClass('sec-custom-fancy')

  }
});

$(document).on('click', '.cv-fancy', function(){  
  $('body').addClass('custom-fancy-rose')
  $.fancybox([
    { href : '#cv-fancybox-popup' }
  ]);
});

$(document).click(function (e) {
  if (!$(e.target).closest('.cv-fancy,.fancybox-opened').length) {
    $('body').removeClass('custom-fancy-rose')

  } 
});

$(document).on('click','.quick-view-button', function(){
  $('body').addClass('cv-see-detail');  
});
$(document).click(function (e) {
  if (!$(e.target).closest('.quick-view-button,.fancybox-opened').length) {
    $('body').removeClass('cv-see-detail') 
  }
});

$(document).on('click','.ScrollBtn', function(){
  var TargetScroll = $(this).attr('scroll');
  $('html, body').animate({
    scrollTop: $(TargetScroll).offset().top - 150
  }, 800);
});

$(document).on('click','.CV_bundle_left_struct,.Cv_bundle,.CV_right_content_bundle', function(){
  $('body').addClass('rose-quick-view') 
});
$(document).click(function (e) {
  if (!$(e.target).closest('.CV_bundle_left_struct,.Cv_bundle,.CV_right_content_bundle,.fancybox-opened').length) {
    $('body').removeClass('rose-quick-view') 
  }
}); 

$(document).ready(function(){
  $('.needsclick').addClass('cv-klaviyo')
});

$(document).ready(function(){ 
  $('.review-popup-button').click(function(){ 
    $(this).parents('.block-review-section-repeated').addClass('popup-active');
    $('body').addClass('body-masked');
  });

  $('.cv-close').click(function(){
    $(this).parents('.block-review-section-repeated').removeClass('popup-active');
    $('body').removeClass('body-masked')
  });
});

$('.code-cv-article-slider').slick({
  slidesToShow: 1,
  arrows: true,
  dots: false,
  asNavFor:'.code-slider-thumbnail',
  fade:true,
  slidesToScroll: 1
}); 

$('.code-slider-thumbnail').slick({
  infinite: true,
  slidesToShow: 9,
  arrows:false,
  dots:false,
  asNavFor: '.code-cv-article-slider',
  slidesToScroll: 1,
  focusOnSelect: true
});


$('.custom-slider-popup-artice').slick({
  slidesToShow: 1,
  arrows: true,
  dots: false,
  fade:true,
  slidesToScroll: 1
}); 


$(document).ready(function(){
  $('.article-open-popup').click(function(){
    $('.code-cv-article-slider').slick('refresh');
    $(this).parents('.cv-main-article-slider').children('.cv-article-image-popup').addClass('popup-article');
    $('body').addClass('body-article');
  });

  $('.close-slider-popup').click(function(){
    $(this).parents('.cv-main-article-slider').children('.cv-article-image-popup').removeClass('popup-article');
    $('body').removeClass('body-article')
  });

});

$(document).ready(function(){
  $(".social-icon-article-left").css("display", "none");
});
$('.slick-arrow').click(function(){
  $(".social-icon-article-left").css("display", "block");
});


$(document).ready(function(){
  $('.accordion_container .accordion_head').on('click touchend', function(e){
    e.preventDefault();
    if( $(this).hasClass('active') ){
      $(this).toggleClass('active');
      $(this).parents('.accordion_container').children('.accordion_body').slideToggle();
    }
    else{
      $('.accordion_head').removeClass('active');
      $('.accordion_body').slideUp();
      $(this).toggleClass('active');
      $(this).parents('.accordion_container').children('.accordion_body').slideToggle();
    }
  }); 


  if ($(window).width() < 769) {
    $('.announcement-bar').children('.blog-logo-jukebx').children('img').click(function(){
      $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').addClass('is-opened');
      $('body').addClass('blog-logo-overlay');
    });

  }
  else{

    $('.announcement-bar').children('.blog-logo-jukebx').children('img').hover(
      function () {
        $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').css('display','block');
      },
      function () {
        //         $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').css('display','none');
      }
    );

    $('.m-header-common-mission-trigger').hover(
      function () {
        $('.m-header-common-mission-trigger').css('display','block');
      },
      function () {
        $('.m-header-common-mission-trigger').css('display','none');
      }
    );

  }
  $('.m-header-common-mission-close').click(function(){
    $(this).parents('.announcement-bar').children('.m-header-common-mission-trigger').removeClass('is-opened');
    $('body').removeClass('blog-logo-overlay');
  });
  $(document).click(function (e) {
    if (!$(e.target).closest('.announcement-bar .blog-logo-jukebx img, .m-header-common-mission-trigger').length) {
      $('.m-header-common-mission-trigger').removeClass('is-opened');
      $('body').removeClass('blog-logo-overlay');
    }
  });

});

$(document).ready(function(){
  const slider = document.querySelector('.review-section-slider');
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {isDown = false;slider.classList.remove('active');});
slider.addEventListener('mouseup', () => {isDown = false;slider.classList.remove('active');});
slider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  slider.scrollLeft = scrollLeft - walk; 
}); 

}) 

$(document).ready(function(){
  const DraggedSlider = document.querySelector('.IndexDraggedSlider');  
  let isDown = false;
  let startX;
  let scrollLeft; 

  DraggedSlider.addEventListener('mousedown', (e) => { 
    isDown = true;
    DraggedSlider.classList.add('active');
    startX = e.pageX - DraggedSlider.offsetLeft;
    scrollLeft = DraggedSlider.scrollLeft;
  });
  DraggedSlider.addEventListener('mouseleave', () => {isDown = false;DraggedSlider.classList.remove('active');});
DraggedSlider.addEventListener('mouseup', () => {isDown = false;DraggedSlider.classList.remove('active');});
DraggedSlider.addEventListener('mousemove', (e) => {
  if(!isDown) return;
  e.preventDefault();
  const x = e.pageX - DraggedSlider.offsetLeft;
  const walk = (x - startX) * 3; //scroll-fast
  DraggedSlider.scrollLeft = scrollLeft - walk;
});


})

$(document).ready(function(){
  const CartDraggedSlider = document.querySelector('.choose-free-sample-grid');  
  let CartisDown = false;
  let CartstartX;
  let CartscrollLeft; 

  CartDraggedSlider.addEventListener('mousedown', (e) => { 
    CartisDown = true;
    CartDraggedSlider.classList.add('active');
    CartstartX = e.pageX - CartDraggedSlider.offsetLeft;
    CartscrollLeft = CartDraggedSlider.scrollLeft;
  });
  CartDraggedSlider.addEventListener('mouseleave', () => {CartisDown = false;CartDraggedSlider.classList.remove('active');});
CartDraggedSlider.addEventListener('mouseup', () => {CartisDown = false;CartDraggedSlider.classList.remove('active');});
CartDraggedSlider.addEventListener('mousemove', (e) => {
  if(!CartisDown) return;
  e.preventDefault();
  const Cartx = e.pageX - CartDraggedSlider.offsetLeft;
  const Cartwalk = (Cartx - CartstartX) * 3; //scroll-fast
  CartDraggedSlider.scrollLeft = CartscrollLeft - Cartwalk;
});

});


































